import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import styled from "styled-components";
import { useAppDispatch } from "../../app/hooks";
import { clearDialogScheduleAction } from "../../app/reducers/schedule-slice";
import { DeliveryGroup } from "../../types/schedule/delivery-group";
import { DeliveryInGroup } from "../../types/schedule/delivery-in-group";
import { Schedule } from "../../types/schedule/schedule";
import Button from "../button/Button";
import CloseLineIcon from "../icons/CloseLineIcon/CloseLineIcon";
import { DeliveryGroupInspector } from "../inspector/DeliveryGroupInspector";
import { DeliveryGroupSwiper } from "../swiper/DeliveryGroupSwiper";

interface Props {
    schedule: Schedule;
    deliveryGroup: DeliveryGroup;
}

interface ImageActionKeysMap {
    [imageUrl: string]: Set<string>;
}

export interface ActionGroupMap {
    [key: string]: ActionGroup;
}

export interface ActionGroup {
    actionKey: string;
    deliveries: DeliveryInGroup[];
}

export const DeliveryGroupDialogContent: React.FC<Props> = ({
    schedule,
    deliveryGroup,
}) => {
    const nodeRef = useRef(null);
    const [imgActionArray, setImgActionArray] = useState<string[]>([]);
    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(clearDialogScheduleAction());
    };

    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleEsc);

        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, []);  // 빈 의존성 배열 - 컴포넌트 마운트/언마운트 시에만 실행

    const getActionGroupMap = (deliveryGroup: DeliveryGroup) => {
        const actionGroupMap: ActionGroupMap = {};
        const imageActionKeysMap: ImageActionKeysMap = {};

        deliveryGroup.deliveriesInGroup.forEach((delivery) => {
            const detail = delivery.inProgressWorkPlace.detail || "";
            const actionKey = `${detail} ${delivery.inProgressWorkPlace.alias}`;

            actionGroupMap[actionKey] = actionGroupMap[actionKey] || {
                actionKey,
                deliveries: [],
            };
            actionGroupMap[actionKey].deliveries.push(delivery);

            delivery.inProgressAction.images.forEach((image) => {
                if (!imageActionKeysMap[image]) {
                    imageActionKeysMap[image] = new Set();
                }
                imageActionKeysMap[image].add(actionKey);
            });
        });

        return { actionGroupMap, imageActionKeysMap };
    };

    const { actionGroupMap, imageActionKeysMap } = getActionGroupMap(deliveryGroup);

    useEffect(() => {
        setImgActionArray([...Object.keys(imageActionKeysMap)]);
    }, [deliveryGroup]);

    return (
        <>
            <Draggable
                nodeRef={nodeRef}
                handle=".handleDraggable"
                defaultPosition={{ x: 0, y: 0 }}
            >
                <DialogueContainer ref={nodeRef} isPickUp={deliveryGroup.isPickUp}>
                    <DialogHeader>
                        <DialogueHeaderScheduleAlias
                            onClick={() => {
                                // copyClipboardJson(deliveryGroup);
                            }}
                            className="handleDraggable"
                            style={{ margin: "0" }}
                        >
                            {schedule.alias || ""} -
                        </DialogueHeaderScheduleAlias>
                        <DialogueHeaderPro className="handleDraggable">
                            {schedule.worker?.name} 프로님
                        </DialogueHeaderPro>
                        <CloseButton
                            color="iconOnly"
                            onClick={handleClose}
                            startIcon={<CloseLineIcon fill="#FFFFFF" />}
                        />
                    </DialogHeader>

                    <DialogContent>
                        {/* {deliveryGroup.isDropOff && (
              )} */}
                        <DeliveryGroupSwiper
                            images={imgActionArray}
                            imageActionKeysMap={imageActionKeysMap}
                        />
                        <DeliveryGroupInspector
                            actionGroupMap={actionGroupMap}
                            schedule={schedule}
                            deliveryGroup={deliveryGroup}
                        />
                    </DialogContent>
                </DialogueContainer>
            </Draggable>
        </>
    );
};

interface DialogueContainerProps {
    isPickUp: boolean;
}

const DialogueContainer = styled.div<DialogueContainerProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -468.5px;
  margin-top: -358px;
  width: 937px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
  background: #ffffff;
  z-index: 1000;
`;

const DialogueHeaderScheduleAlias = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 48px;
  color: #ebeef3;
  padding-left: 24px;
  height: 100%;
`;

const DialogueHeaderPro = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 48px;
  color: #ebeef3;
  padding-left: 4px;
  width: 70%;
  height: 100%;
`;

const CloseButton = styled(Button)`
  margin-left: auto;
  min-width: unset;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  padding: 7px;
  margin-right: 17px;
`;

const DialogHeader = styled.div`
  height: 48px;
  background: #121a2b;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
`;

const DialogContent = styled.div`
  display: flex;
`;
